import { queryOptions } from '@tanstack/react-query'
import { memberApi } from './api'

export const memberQueries = {
  all: () => ['members'],
  list: (orgId: string) => {
    return queryOptions({
      queryKey: [...memberQueries.all(), { orgId }],
      queryFn: () => memberApi.csc.listMembers({ orgId }),
      enabled: Boolean(orgId),
    })
  },
  roles: () => {
    return queryOptions({
      queryKey: [...memberQueries.all(), 'roles'],
      queryFn: () => memberApi.csc.listRoles(),
    })
  },
}
